import React, { useCallback } from 'react';
import LabelledTickbox from '../LabelledTickbox';
import DataCell from './DataCell';

const SelectCell = ({
    rowIndex,
    data,
    accessor,
    scrollPxH,
    scrollPxV,
    isSticky,
    style,
    onHover,
    isHighlighted,
    onTick,
    disabled = false,
    reverseElements,
    gap = 12,
    size = 18,
    tickboxField,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    /**
     * Event handler for LabelledTickbox click event
     * @param {Event} event - event
     */
    const onClick = useCallback(
        (event) => {
            onTick(data, disabled, event);
        },
        [onTick, disabled]
    );

    return (
        <DataCell
            rowIndex={rowIndex}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            id={`${accessor}${rowIndex}`}
            style={{ height: rowHeight, ...style }}
            isSticky={isSticky}
            onHover={onHover}
            isHighlighted={isHighlighted}
            deleteRowSelected={deleteRowSelected}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            <LabelledTickbox
                reverseElements={reverseElements}
                gap={gap}
                size={size}
                style={{
                    color: '#414141',
                    fontFamily: 'roboto',
                    fontSize: 14,
                    fontWeight: 500
                }}
                containerStyle={{
                    justifyContent: 'space-between'
                }}
                title={data[accessor]}
                value={data[tickboxField]}
                onClick={onClick}
            />
        </DataCell>
    );
};

export default SelectCell;
